import React, { useEffect } from 'react';
import TopBanner from '../../../components/topBanner/topBanner';
import imgBanner from "../../../images/banner/banner-tin-tuc.jpg";
import TITLE_CENTER from '../../../components/title/TitleCenter';
import TypicalProjectSlider from './TypicalProjectSlider';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import { normalizeLang } from '../../../utils/localeDataLoader';

const PATH_VI = '/du-an-tieu-bieu';
const PATH_OTHER = '/typical-projects';

function TypicalProject() {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);

    // Điều hướng path theo ngôn ngữ khi i18n.language thay đổi
    useEffect(() => {
        const lang = normalizeLang(i18n.language);
        const currentPath = location.pathname;

        if (lang === 'vi' && currentPath === PATH_OTHER) {
            navigate(`${PATH_VI}${location.search}`, { replace: true });
        } else if (lang !== 'vi' && currentPath === PATH_VI) {
            navigate(`${PATH_OTHER}${location.search}`, { replace: true });
        }
    }, [i18n.language, location.pathname, location.search, navigate]);

    return (
        <div className='typicalProject_container'>
            <TopBanner
                titleCenter={t('home.typical_projects_title')}
                imgBanner={imgBanner}
                pageName={t('home.typical_projects_title')}
            />
            <div className='layout_container'>
                <TITLE_CENTER
                    text={t('home.typical_projects_title')}
                />
                <TypicalProjectSlider />
            </div>
        </div>
    );
}

export default TypicalProject;
